import {
  SWITCH_PREPAY_SCHEDULE_TYPE_REQUEST,
  SWITCH_PREPAY_SCHEDULE_TYPE_SUCCESS,
} from "../actions/prepaySettings/PrepaySettingsActionsTypes";
import { GET_SCHEDULE_LIST_SUCCESS } from "../actions/schedules/SchedulesActionTypes";
import { IAppActions } from "../types/IAppActions";
import { IRestaurantSettingsStore } from "../types/IRestaurantSettingsStore";
import { SET_SECTION_ID } from "../actions/restaurantsSettings/RestaurantsSettingsActionsTypes";

const initState: IRestaurantSettingsStore = {
  isActiveRestaurantSchedule: undefined,
  sectionId: undefined,
};

export default function reducer(
  state: IRestaurantSettingsStore = initState,
  action: IAppActions,
): IRestaurantSettingsStore {
  switch (action.type) {
    case SWITCH_PREPAY_SCHEDULE_TYPE_SUCCESS: {
      return {
        ...state,
        isActiveRestaurantSchedule: action.payload.isActiveRestaurantSchedule,
      };
    }

    case SWITCH_PREPAY_SCHEDULE_TYPE_REQUEST: {
      return {
        ...state,
        isActiveRestaurantSchedule: action.payload.isActiveRestaurantSchedule,
      };
    }

    case SET_SECTION_ID: {
      return {
        ...state,
        sectionId: action.payload.sectionId,
      };
    }

    case GET_SCHEDULE_LIST_SUCCESS: {
      return {
        ...state,
        isActiveRestaurantSchedule: action.payload.prepaySchedules.length === 0,
      };
    }

    default:
      return state;
  }
}
